<template>
  <div
    class="app-loading"
    :class="`${prefix}`">
    <div
      class="app-loading__backdrop">
    </div>
    <div
      class="app-loading__content">
      <span
        class="app-loading__spinner">
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppLoading',
  data() {
    return {
      prefix: 'el-app-loading',
    };
  },
  mounted() {
    const el = this.$parent.$el;
    el.className += ' app-loading-lock';
  },
  destroyed() {
    const el = this.$parent.$el;
    el.className = el.className.replace(' app-loading-lock', '');
  },
};
</script>

<style lang="scss">
.app-loading {
  &__backdrop {
    background-color: #ffffff;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  &__content {
    text-align: center;
  }

  &__spinner {
    display: inline-block;
    vertical-align: middle;
    border-style: solid;
    border-color: #4875b3;
    border-top-color: transparent !important;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    border-width: 2px;
    animation: rotate .4s linear infinite;
  }
  &-lock {
    overflow: hidden;
  }
}
@keyframes rotate {
  100% {
    transform: rotate(360deg) translateZ(0);
  }
}
</style>
